import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import Announcements from './announcements.jsx';

const Header = () => {
    const user = JSON.parse(localStorage.getItem('userInfo'));
    const [currentTime, setCurrentDateTime] = useState('');

    useEffect(() => {
        const interval = setInterval(() => {
            const date = new Date();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
            const formattedTime = `${formattedHours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds} ${ampm}`;
            const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())}, ${date.getFullYear()}`;
            setCurrentDateTime(`${formattedDate} ${formattedTime}`);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const getMonthName = (monthIndex) => {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return months[monthIndex];
    };
    
    const navigate = useNavigate();

    const handleLogout = async () => {
        const isConfirm = await Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Logout'
        }).then((result) => {
            return result.isConfirmed
        });

        if(!isConfirm){
            return;
        }

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/logout`)
            .then(({data})=>{
                localStorage.removeItem('userInfo');
                localStorage.removeItem('token'); 
                toast.success(data.message);          
                navigate('/');
            }).catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    };


    return (
        <div className="header">
            <div className="header-left">
                <Link className="logo">
                    <img src={`${process.env.REACT_APP_URL}/assets/img/favicon.ico`} width="40" height="40" alt="Logo" />
                </Link>
                <Link className="logo collapse-logo">
                    <img src={`${process.env.REACT_APP_URL}/assets/img/favicon.ico`} alt="Logo" />
                </Link>
                <Link className="logo2">
                    <img src={`${process.env.REACT_APP_URL}/assets/img/favicon.ico`} width="40" height="40" alt="Logo" />
                </Link>
            </div>

            <Link to="javascript:void(0)" id="toggle_btn" role="button">
                <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </Link>

            <div className="page-title-box">
                <h3>Visions</h3>
            </div>

            <Link id="mobile_btn" className="mobile_btn" to="#sidebar">
                <i className="fa-solid fa-bars"></i>
            </Link>

            <ul className="nav user-menu">
                <li className="nav-item dropdown has-arrow main-drop mt-2">
                    <span className="text-white">{currentTime} &nbsp;&nbsp;&nbsp; 
                        {(user.role_name !== 'Super-Admin' &&
                            <Announcements />
                        )}
                    </span>
                    <Link to="#" className="dropdown-toggle nav-link" data-bs-toggle="dropdown">
                        <span>{user.name}</span>
                    </Link>
                    <div className="dropdown-menu">
                        <Link className="dropdown-item" to="/profile">My Profile</Link>
                        <Link className="dropdown-item" onClick={handleLogout}>Logout</Link>
                    </div>
                </li>
            </ul>

            <div className="dropdown mobile-user-menu">
                <Link to="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="fa-solid fa-ellipsis-vertical"></i></Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <Link className="dropdown-item" to="/profile">My Profile</Link>
                    <Link className="dropdown-item" onClick={handleLogout}>Logout</Link>
                </div>
            </div>

        </div>
    );
}

export default Header